import { CarrierImportVerificationStatus } from './carrier-import-verification-status';
import { CarrierImportVerificationRowResult } from './carrier-import-verification-row-result';
import { CarrierImportColumn } from './carrier-import-column';

export class CarrierImportVerificationResult {
  public status: CarrierImportVerificationStatus;
  public reason: CarrierImportVerificationErrorReason;
  public carriersRows: CarrierImportVerificationRowResult[];
  public carrierManagersRows: CarrierImportVerificationRowResult[];
  public carriersColumns: CarrierImportColumn[];
  public missingCarriersColumns: CarrierImportColumn[];
  public unexpectedCarriersColumns: { name: string, position: number }[];
  public carrierManagersColumns: CarrierImportColumn[];
  public missingCarrierManagersColumns: CarrierImportColumn[];
  public unexpectedCarrierManagersColumns: { name: string, position: number }[];
  public totalNumberOfCarriers: number;
  public totalNumberOfCarriersInSuccess: number;

  static fromDto(data: any): CarrierImportVerificationResult {
    if (!data) {
      return null;
    }

    const importResult = new CarrierImportVerificationResult();

    let carriersRows: CarrierImportVerificationRowResult[]        = [];
    let carriersColumns: CarrierImportColumn[]                    = [];
    let missingCarriersColumns: CarrierImportColumn[]             = [];
    let carrierManagersRows: CarrierImportVerificationRowResult[] = [];
    let carrierManagersColumns: CarrierImportColumn[]             = [];
    let missingCarrierManagersColumns: CarrierImportColumn[]      = [];

    importResult.status                           = data.status;
    importResult.reason                           = data.reason;
    importResult.totalNumberOfCarriers            = data.total_number_of_carriers;
    importResult.totalNumberOfCarriersInSuccess   = data.total_number_of_carriers_in_success;
    importResult.unexpectedCarriersColumns        = data.unexpected_carriers_columns || [];
    importResult.unexpectedCarrierManagersColumns = data.unexpected_carrier_managers_columns || [];
    if (data.carriers_rows) {
      carriersRows = data.carriers_rows.map(r => CarrierImportVerificationRowResult.fromDto(r, importResult.unexpectedCarriersColumns));
    }
    if (data.carrier_managers_rows) {
      carrierManagersRows = data.carrier_managers_rows.map(r => CarrierImportVerificationRowResult.fromDto(r, importResult.unexpectedCarrierManagersColumns));
    }
    if (data.carriers_columns) {
      carriersColumns = data.carriers_columns.map(c => CarrierImportColumn.fromDto(c));
    }
    if (data.carrier_managers_columns) {
      carrierManagersColumns = data.carrier_managers_columns.map(c => CarrierImportColumn.fromDto(c));
    }
    if (data.missing_carriers_columns) {
      missingCarriersColumns = data.missing_carriers_columns.map(c => CarrierImportColumn.fromDto(c));
    }
    if (data.missing_carrier_managers_columns) {
      missingCarrierManagersColumns = data.missing_carrier_managers_columns.map(c => CarrierImportColumn.fromDto(c));
    }

    importResult.carriersRows                  = carriersRows;
    importResult.carriersColumns               = carriersColumns;
    importResult.missingCarriersColumns        = missingCarriersColumns;
    importResult.carrierManagersRows           = carrierManagersRows;
    importResult.carrierManagersColumns        = carrierManagersColumns;
    importResult.missingCarrierManagersColumns = missingCarrierManagersColumns;

    return importResult;
  }
}

export enum CarrierImportVerificationErrorReason {
  EMPTY_FILE                       = 'EMPTY_FILE',
  EMPTY_ROWS                       = 'EMPTY_ROWS',
  COULD_NOT_EXTRACT_HEADER_COLUMNS = 'COULD_NOT_EXTRACT_HEADER_COLUMNS',
  INVALID_HEADER_COLUMNS           = 'INVALID_HEADER_COLUMNS',
  PARSING_ERROR                    = 'PARSING_ERROR',
  VALIDATION_ERROR                 = 'VALIDATION_ERROR',
  DUPLICATION_ERROR                = 'DUPLICATION_ERROR'
}
